export const formatPrice = (price: number) =>
  price.toLocaleString("pl-PL", { minimumFractionDigits: 2 });
